import { render, staticRenderFns } from "./PopupVerifyResult.vue?vue&type=template&id=b232814e&scoped=true&"
import script from "./PopupVerifyResult.vue?vue&type=script&lang=js&"
export * from "./PopupVerifyResult.vue?vue&type=script&lang=js&"
import style0 from "./PopupVerifyResult.vue?vue&type=style&index=0&id=b232814e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b232814e",
  null
  
)

export default component.exports